<div class="content-dialog">
    <div class="row mt-2 mb-5 mb-md-4">
        <div class="col-12">
            <p class="text-center text-color-primary font-semi-bold" style="font-size: 16px;">REGISTRA TU LECTURA EN 3
                PASOS</p>
        </div>
    </div>
    <div class="row mb-4 pl-3">
        <div class="col-12 col-md-4 mb-4 mb-md-0">
            <div class="content-card d-flex justify-content-center justify-content-md-start">
                <div class="content-column">
                    <p class="text-center text-color-primary font-semi-bold mb-2 font-small">1. Verifica tu número de medidor</p>
                    <div class="content-img">
                        <img [src]="billImage" alt="">
                    </div>
                    <p class="text-color-secondary mt-2 text-center">Verifica que tu número de medidor físico coincida
                        con el señalado en tu recibo.</p>
                </div>
                <mat-icon class="text-color-primary d-none d-md-block" style="font-size: 48px; margin-top: 95px;">
                    keyboard_arrow_right</mat-icon>
            </div>
        </div>
        <div class="col-12 col-md-4 mb-4 mb-md-0">
            <div class="content-card d-flex justify-content-center justify-content-md-start">
                <div class="content-column">
                    <p class="text-center text-color-primary font-semi-bold mb-2 font-small">2. Toma la foto y súbela</p>
                    <div class="content-img">
                        <img [src]="handBookImage">
                    </div>
                    <p class="text-color-secondary mt-2 text-center">Toma la foto de tu medidor como se muestra en el
                        ejemplo de arriba y súbela.</p>
                </div>
                <mat-icon class="text-color-primary d-none d-md-block" style="font-size: 48px; margin-top: 95px;">
                    keyboard_arrow_right</mat-icon>
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="content-card d-flex justify-content-center justify-content-md-start">
                <div class="content-column">
                    <p class="text-center text-color-primary font-semi-bold mb-2 font-small">3. Coloca tu consumo actual:</p>
                    <div class="content-img">
                        <img src="./assets/img/step3.png" alt="">
                    </div>
                    <p class="text-center text-color-secondary mt-2">Coloca tu consumo actual que aparece señalado en el
                        rectángulo celeste sin considerar los ceros de adelante y ¡Listo!</p>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-12 text-center">
            <button mat-dialog-close mat-flat-button class="style-button-1 mt-2 w-30">
                <span>Entendido</span>
            </button>
        </div>
    </div>
</div>